import { render, staticRenderFns } from "./TabRelatie.vue?vue&type=template&id=03e9e96c"
import script from "./TabRelatie.vue?vue&type=script&lang=js"
export * from "./TabRelatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports